import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Glossary from "@/pages/Glossary";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SharedView from "@/pages/SharedView";
import Shield from "@/pages/Shield";
import Assistant from "@/pages/Assistant";
import Decoder from "@/pages/Decoder";
import Simulator from "@/pages/Simulator";
import Quiz from "@/pages/Quiz";
import LegalNotice from "@/pages/LegalNotice";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import CookieBanner from "@/components/CookieBanner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-lg text-[#4A4A4A]">
        …
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/partage/:token" element={<SharedView />} />
        <Route path="/protection" element={<Shield />} />
        <Route
          path="/assistant"
          element={
            <ProtectedRoute>
              <Assistant />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decodeur"
          element={
            <ProtectedRoute>
              <Decoder />
            </ProtectedRoute>
          }
        />
        <Route path="/decouvrir" element={<Onboarding />} />
        <Route path="/simulateur" element={<Simulator />} />
        <Route
          path="/quiz"
          element={
            <ProtectedRoute>
              <Quiz />
            </ProtectedRoute>
          }
        />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/confidentialite" element={<Privacy />} />
        <Route path="/cgu" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/glossary"
          element={
            <ProtectedRoute>
              <Glossary />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRoutes />
          <CookieBanner />
          <Toaster
            richColors
            position="top-center"
            toastOptions={{
              style: { fontSize: "1rem", padding: "1rem" },
            }}
          />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
